<ng-container *ngIf="!showDefaultImage && !showShortName">
  <img alt="avatar-icon" (error)="showDefaultImage = true" class="avatar {{fontClass}}" [src]="fullPath" />
</ng-container>
<ng-container *ngIf="showDefaultImage || showShortName">
  <span class="avatar {{fontClass}}">{{userShortName}}</span>
</ng-container>

